import { React, _ } from '../../../lib';
import { Alerts } from '../../component-main';
import { reactFlyout } from '../../component-react';
import { FormButton, FormButtonSet } from '../buttons';
import { Combobox } from '../combobox';
import { CJSX } from '../meta-types';
import { FormRow } from '../wrappers';
import { getTagComboboxOptions } from './tags';
export const bulkUploadNotes = (rs, filesAll, onResolve) => {
    const existingAttachmentChecksums = _.chain(rs.props.notes)
        .filter(x => !x.Deleted && !x.Archived)
        .map(x => x.Attachment?.Checksum)
        .compact()
        .uniq()
        .value();
    const files = filesAll.filter(x => !existingAttachmentChecksums.includes(x.Checksum));
    if (files.length == 0) {
        Alerts.Alert({ msg: 'No new files to upload' });
        onResolve();
        return;
    }
    reactFlyout('Are you sure?', [360, 200], React.createElement(BulkUploadNotesConfirm, { rs: rs, files: files, onResolve: onResolve }), {
        closeCallback: onResolve,
    });
};
const BulkUploadNotesConfirm = (props) => {
    const rs = props.rs;
    const [tags, setTags] = React.useState(rs.state.filteredTags ?? []);
    const [isLoading, setIsLoading] = React.useState(false);
    const [msg, setMsg] = React.useState('');
    const [isDone, setIsDone] = React.useState(false);
    const plural = props.files.length > 1 ? 'files' : 'file';
    const confirmationPrompt = rs.props.adding?.bulkUpload?.confirmationPrompt?.(props.files) ??
        `Are you sure you want to upload ${props.files.length} ${plural}?`;
    return (React.createElement(React.Fragment, null,
        confirmationPrompt,
        React.createElement(CJSX, { cond: Boolean(rs.props.tagging) },
            React.createElement(FormRow, { lbl: "Tags" },
                React.createElement(Combobox, { value: tags, onUpdate: setTags, multiple: true, options: getTagComboboxOptions(rs.props.tagging?.options) }))),
        React.createElement(FormButtonSet, { loading: isLoading, msg: msg, tick: isDone },
            React.createElement(FormButton, { lbl: "OK", type: "submit", onClick: () => {
                    setIsLoading(true);
                    setMsg('');
                    rs.props.adding?.bulkUpload?.onUpload({
                        files: props.files,
                        tags: tags,
                    }, () => {
                        setMsg('Done');
                        setIsDone(true);
                        setIsLoading(false);
                        props.onResolve();
                        props.flyout?.Close();
                    });
                } }),
            React.createElement(FormButton, { lbl: "Cancel", onClick: () => {
                    props.flyout?.Close();
                    props.onResolve();
                } }))));
};
//# sourceMappingURL=bulk-upload.js.map